import { createStore } from 'vuex';

import { application } from './application';
import { auth } from './auth';
import { childEntities } from './childEntities';
import { files } from './files';
import { eoi } from './eoi';
import { calculator } from './calculator';
import { ui } from './ui';
import { notifications } from './notifications';
import { settings } from './settings';

const store = createStore({
  modules: {
    application,
    auth,
    childEntities,
    files,
    eoi,
    calculator,
    ui,
    notifications,
    settings
  }
});

export default store;
